import { environment } from "@/enviroment";
import {
  NotificationPush,
  NotificationPushRepository,
} from "../domain/NotificationPush";

const BASE_URL = `${environment.openBaas}/v1/notifications_push`;

export class HttpNotificationPushRepository
  implements NotificationPushRepository
{
  async getNotifications(): Promise<NotificationPush[]> {
    const res = await fetch(BASE_URL, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch push notifications");
    const data = await res.json();
    return data.response;
  }

  async getNotificationById(id: string): Promise<NotificationPush | null> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      credentials: "include",
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to fetch push notification");
    const data = await res.json();
    return data.response;
  }

  async createNotification(
    notification: NotificationPush
  ): Promise<NotificationPush> {
    const res = await fetch(BASE_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(notification),
    });

    if (!res.ok) throw new Error("Failed to create push notification");
    const data = await res.json();
    return data.response;
  }

  async deleteNotification(id: string): Promise<void> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to delete push notification");
  }
}
